import { Button, Checkbox, FormControlLabel, Grid, Paper } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import FabButton from 'src/components/fab-button'
import ModalDialogPage from 'src/components/modal-dialog'
import { localeBRDataGridText } from 'src/utils/data-grid-local-text'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import BondsService from 'src/services/bonds-service'
import PropTypes from 'prop-types'
import EditableInputComponent from 'src/components/editable-input-component'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import ClientService from 'src/services/client-service'
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded'
import { formatDateString } from 'src/utils/format-date'
import ConfirmDialog from 'src/components/confirm-dialog'
import MultiSelectAutoComplete from 'src/components/mult-select-autocomplete'
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'

const RegisterBonds = (props) => {
  const initialISINList = [
    { id: 1, 
      ISIN: '', 
      Clientes: [] }
  ]

  const initialEditIsin = {
    ISIN: '',
    Clientes: [],
    UpdateClientes: [] 
  }

  const [idListDelete, setIdListDelete] = useState([])
  const [productList, setProductList] = useState([])
  const [productListTmp, setProductListTmp] = useState([])
  const [clientList, setClientList] = useState([])
  const [editIsin, setEditIsin] = useState(initialEditIsin)
  const [dueDate, setDueDate] = useState(false)
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [dialogDelete, setDialogDelete] = useState(false)
  const [openEditClientIsin, setOpenEditClientIsin] = useState(false)
  const bondsService = new BondsService()
  const clientService = new ClientService()
  const [newIsinList, setNewIsinList] = useState(initialISINList)

  useEffect(() => {
    loadBonds()
  }, [])

  const loadClientPrices = () => {
    props.loading(true)
    clientService.loadClientPrices()
      .then((response) => {
        props.loading(false)
        const { body } = response
        const raw = body?.data || []
        const clientOptions = raw.map((item) => ({ value: item.ID, label: item.Nome }))
        const uniqueClientOptions = clientOptions.filter(
            (client, index, self) =>
                index === self.findIndex(c => c.label === client.label)
            )
            const clientes = [{ value: 10, label: 'C2P' }, ...uniqueClientOptions]

            setClientList(clientes)
        })
      }

  const loadBonds = () => {
    props.loading(true)
    bondsService.getBonds()
      .then(response => {
        const { body } = response
        const raw = Array.isArray(body) ? body : body?.data || []
        const list = raw.map((obj, index) => ({ ...obj, id: index }))
        setProductList(list)
        setProductListTmp(list)
        loadClientPrices()
      })
      .finally(() => {
        props.loading(false)
      })
  }

  const onChangeDueDate = (event) => {
  const checked = event.target.checked
  setDueDate(checked)

  if (!checked) {
    setProductList(productListTmp)
    return
  }

  const today = dayjs().startOf('day').valueOf()

  const expired = productListTmp.filter((p) => { const v = p.Vencimento ?? p.vencimento
    if (!v) return false

    let d = dayjs(v)

    if (!d.isValid() && typeof v === 'string' && v.includes('/')) {
      const [dd, mm, yyyy] = v.split('/')
      d = dayjs(`${yyyy}-${mm}-${dd}`)
    }

    return d.isValid() && d.startOf('day').valueOf() <= today
  })

  setProductList(expired)
}

  const actionButton = {
    icon: <AddRoundedIcon />,
    onClick: () => {
      setNewIsinList(initialISINList)
      setOpenAddProduct(true)
    },
    color: 'primary',
  }

  const addClienteIsin = async (updateClient) => {
    const filter = updateClient.UpdateClientes.filter(
      obj1 => !editIsin.UpdateClientes.some(obj2 => obj1.value === obj2.value)
    )[0]
    props.loading(true)
    await bondsService.registerNewIsins({ ISIN: editIsin.ISIN, IDCliente_id: filter.value }).finally
    openModalEditIsins(editIsin.ISIN)
  }

  const removeClientIsin = async (updateClient) => {
        const filter = editIsin.UpdateClientes.filter(
            obj1 => !updateClient.UpdateClientes.some(obj2 => obj1.value === obj2.value)
        )[0]
        props.loading(true)
        await bondsService.deleteIsin(filter.value).finally(() => props.loading(false))
        openModalEditIsins(editIsin.ISIN)
  }

  const handleEditClient = (value) => {
        const distinctSelectedValues = value.filter(
            (obj, index, self) =>
                index === self.findIndex(o => o.value === obj.value && o.label === obj.label))
        console.log("distinctSelectedValues", distinctSelectedValues)

        const updateClient = { ...editIsin, UpdateClientes: distinctSelectedValues }

        if (updateClient.UpdateClientes.length > editIsin.UpdateClientes.length) {
            addClienteIsin(updateClient)
        }

        if (editIsin.UpdateClientes.length > updateClient.UpdateClientes.length) {
            removeClientIsin(updateClient)
        }
    }

    const deleteRow = async () => {
        props.loading(true)
        for (const idItem of idListDelete) {
            await bondsService.deleteIsin(idItem)
        }
        props.loading(false)
        loadBonds()
    }
  

  const openDeleteIsin = (params) => {
  props.loading(true)
  bondsService.getClientsFromIsin(params.row.ISIN)
    .then((response) => {
      props.loading(false)
      const { body } = response
      const { results } = body
      setDialogDelete(true)
      const IDList = results.map((item) => item.ID)
      setIdListDelete(IDList)
    })
    .catch(() => {
      props.loading(false)
    })
}

  const openModalEditIsins = (isin) => {
    props.loading(true)
    bondsService.getClientsFromIsin(isin)
      .then((response) => {
        props.loading(false)
        const { body } = response
        const { results } = body
        setOpenEditClientIsin(true)
        
        let list = []
        for (const result of results) {
            console.log(result)
            list.push({
                value: result.IDCliente,
                label: result.NomeCliente,
                ID: result.ID
            })
        }

        console.log(list)
        console.log(results)

        setEditIsin({
          ISIN: isin,
          Clientes: results,
          UpdateClientes: results.map(result => ({ value: result.ID, label: result.NomeCliente, }))
      })
      })
      .finally(() => {
        props.loading(false)
      })
  }

  const columns = [
    { field: 'id', headerName: '#', maxWidth: 100 },
    { field: 'ISIN', headerName: 'ISIN', flex: true, minWidth: 250 },
    {
      field: 'CBonds',
      headerName: 'CBonds',
      flex: 1,
      type: 'date',
      valueFormatter: (params) => formatDateString(params.value),
      minWidth: 150,
    },
    {
      field: 'PrecosProcessados',
      headerName: 'Preços Processados',
      flex: 1,
      type: 'date',
      valueFormatter: (params) => formatDateString(params.value),
      minWidth: 150,
    },
    {
      field: 'Clientes',
      headerName: 'Clientes',
      flex: true,
      minWidth: 150,
      renderCell: (params) => (
        <Button onClick={() => {
            setEditIsin(initialEditIsin)
            openModalEditIsins(params.row.ISIN)
          }}><OpenInNewRoundedIcon /></Button>
      )
    },
    {
      field: 'Remover',
      headerName: 'Remover',
      flex: true,
      minWidth: 150,
      renderCell: (params) => {
          return <Button color="error" onClick={() => openDeleteIsin(params)}><DeleteOutlineOutlinedIcon /></Button>
      }
    },
  ]

  const handleISINChange = (field, id, value) => {
    const existIsin = productList.filter(item => item.ISIN === value)
    if (existIsin.length > 0) {
      props.alert(`ISIN: ${value} já cadastrado`, 'warning')
    }

    setNewIsinList(prevState => prevState.map(product => {
        return product.id === id ? { ...product, [field]: value } : product
    }))
  }

  const handleClientChange = (id, value) => {
    console.log(value)
    const index = newIsinList.findIndex(product => product.id === id)
    if (index === -1) return

    const updatedProduct = { ...newIsinList[index], Clientes: value }
    const updatedList = [...newIsinList]
    updatedList[index] = updatedProduct

    setNewIsinList(updatedList)
  }

  const addNewIsinRegister = () => {
    setNewIsinList((prevState) => {
      const lastId = prevState[prevState.length - 1].id
      const nextId = lastId + 1
      return [
        ...prevState, 
        {
           id: nextId, 
           ISIN: '', 
           Clientes: [] 
        }
      ]
    })
  }

  const handleRemoveISIN = (id) => {
    console.log("handleRemoveISIN", id)

    if (newIsinList.length < 2) return
    const list = newIsinList.filter(item => item.id !== id)
    setNewIsinList(list)
  }

  const registerProducts = async () => {
    setOpenAddProduct(false)
    newIsinList.forEach((item) => {
            item.Clientes.forEach(async (client) => {
                const body = {
                    'ISIN': item.ISIN,
                    'IDCliente_id': client.value
                }
                props.loading(true)
                await bondsService.registerNewIsins(body)
            })
        })
        loadBonds()
    }

  return (
    <>
      <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
        <Grid item>
          <Grid item>
            <Button variant="outlined" onClick={() => loadBonds()}>
              <RefreshRoundedIcon />
            </Button>
          </Grid>
        </Grid>
        <Grid item>
          <FormControlLabel
            label="Vencidos"
            control={
              <Checkbox checked={dueDate} onChange={onChangeDueDate} />
            }
          />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} md={12} sm={12} xl={12}>
          <Paper>
            <DataGrid
              autoHeight
              rows={productList}
              columns={columns}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              pageSizeOptions={[10, 25, 50, 100]}
              disableRowSelectionOnClick
              sortingOrder={['asc', 'desc']}
              localeText={localeBRDataGridText}
            />
          </Paper>
        </Grid>
      </Grid>

      <br /><br /><br />
      <ModalDialogPage
        open={openAddProduct}
        title="Cadastro de Novos ISIN's"
        close={() => setOpenAddProduct(false)}
        button={<FabButton action={actionButton} />}
      >
        <Grid container direction={'column'} rowSpacing={2}>
          <Grid item width={'100%'}>
            <DataGrid
              autoHeight={false}
              autoPageSize={false}
              showColumnVerticalBorder
              showCellVerticalBorder
              hideFooter
              rows={newIsinList}
              columns={[
                {
                  field: 'id',
                  headerName: '#',
                  align: 'center',
                  disableColumnMenu: true,
                  sortable: false,
                  headerAlign: 'center',
                },
                {
                  field: 'ISIN',
                  headerName: 'ISIN',
                  align: 'center',
                  disableColumnMenu: true,
                  sortable: false,
                  maxWidth: 200,
                  minWidth: 200,
                  headerAlign: 'center',
                  renderCell: ({ id, value }) => (
                    <EditableInputComponent
                      editable
                      fieldValue={value}
                      handleChange={(cellValue) => handleISINChange('ISIN', id, cellValue)}
                    />
                  ),
                },
                {
                  field: 'Clientes',
                  headerName: 'Clientes',
                  align: 'center',
                  disableColumnMenu: true,
                  sortable: false,
                  flex: 1,
                  headerAlign: 'center',
                  renderCell: ({ id }) => {
                    const values = newIsinList.find(c => c.id === id)?.Clientes || []
                    return (
                      <MultiSelectAutoComplete
                        id={`multiple-${id}`}
                        options={clientList}
                        limitTags={4}
                        selectedValues={values}
                        handleChange={(value) => handleClientChange(id, value)}
                      />
                    )
                  }
                },
                {
                  field: 'Remover',
                  headerName: 'Remover',
                  align: 'center',
                  disableColumnMenu: true,
                  sortable: false,
                  headerAlign: 'center',
                  renderCell: (params) => (
                    <Button onClick={() => handleRemoveISIN(params.row.id)} color="error">
                      <DeleteOutlineOutlinedIcon />
                    </Button>
                  ),
                }
              ]}
              disableRowSelectionOnClick
            />
          </Grid>

          <br />

          <Grid container justifyContent={'space-between'}>
            <Grid item>
              <Grid container spacing={1} justifyContent={'flex-start'}>
                <Grid item>
                  <Button variant="contained" onClick={addNewIsinRegister}>
                    <AddRoundedIcon />ISIN
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container spacing={1} justifyContent={'flex-end'}>
                <Grid item>
                  <Button variant="outlined" onClick={() => setOpenAddProduct(false)}>Cancelar</Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" onClick={registerProducts}>Cadastrar</Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ModalDialogPage>

      <ModalDialogPage
        open={openEditClientIsin}
        title={`Atualizar Clientes de Bonds | ISIN: ${editIsin.ISIN}`}
        close={() => setOpenEditClientIsin(false)}
      >
        <Grid container direction={'column'} rowSpacing={2}>
          <Grid item sm={12} md={6} xl={8}>
            <MultiSelectAutoComplete
              label={'Lista de Clientes'}
              options={clientList}
              limitTags={10}
              helperText={editIsin.UpdateClientes.length === 0 ? 'Necessário informar no mínimo um cliente' : null}
              selectedValues={editIsin.UpdateClientes}
              handleChange={(value) => handleEditClient(value)}
            />
          </Grid>

          <br />

          <Grid container justifyContent={'flex-end'}>
            <Grid item>
              <Grid container spacing={1} justifyContent={'flex-end'}>
                <Grid item>
                  <Button variant="outlined" onClick={() => setOpenEditClientIsin(false)}>Fechar</Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ModalDialogPage>

      <ConfirmDialog
        open={dialogDelete}
        title={'Deseja remover esse registro?'}
        onConfirm={deleteRow}
        onClose={() => setDialogDelete(false)}
      >
        <span>Essa ação não pode ser desfeita.</span>
      </ConfirmDialog>
    </>
  )
}

RegisterBonds.propTypes = {
  loading: PropTypes.func,
  alert: PropTypes.func
}

export default RegisterBonds
